import { SortOrderType } from '@repo/common';
import { cn } from '@repo/shadcn';
import { ArrowDown, ArrowUp } from 'lucide-react';
import { FC, ReactNode } from 'react';

import { useUrlFilter } from '../../../hooks';

type DataTableHeaderProps = {
    children?: ReactNode;
    align?: 'left' | 'center' | 'right';
    sortByColumnName?: string;
};

export const DataTableHeader: FC<DataTableHeaderProps> = ({
    align,
    children,
    sortByColumnName,
}) => {
    const { sortOrder, setSortBy, setSortOrder } = useUrlFilter({
        defaultSortBy: 'name',
        defaultSortOrder: SortOrderType.ASC,
    });

    const alignmentClass =
        align === 'center'
            ? 'justify-center'
            : align === 'right'
              ? 'justify-end'
              : 'justify-start';

    const handleToggleSort = () => {
        // Sorting logic can be implemented here
        if (!sortByColumnName) {
            return;
        }

        if (sortOrder === SortOrderType.ASC) {
            setSortOrder(SortOrderType.DESC);
        } else {
            setSortOrder(SortOrderType.ASC);
        }
        setSortBy(sortByColumnName);
    };

    const renderSortIcon = () => {
        if (!sortByColumnName) {
            return null;
        }

        console.log('Current Sort Order:', sortOrder);

        if (sortOrder === SortOrderType.ASC) {
            return <ArrowDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />;
        }
        return <ArrowUp className="ml-2 h-4 w-4 shrink-0 opacity-50" />;
    };

    return (
        <div
            onClick={handleToggleSort}
            className={cn(
                'flex items-center',
                alignmentClass,
                sortByColumnName && 'cursor-pointer',
            )}
        >
            {children}
            {renderSortIcon()}
        </div>
    );
};

DataTableHeader.displayName = 'DataTableHeader';
